import { render, staticRenderFns } from "./DmsSettingsForm.vue?vue&type=template&id=37d04699&scoped=true"
import script from "./DmsSettingsForm.vue?vue&type=script&lang=js"
export * from "./DmsSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./DmsSettingsForm.vue?vue&type=style&index=0&id=37d04699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d04699",
  null
  
)

export default component.exports